<template>
    <div class="disclaimer">
        <p class="paragraph paragraph--small"><span>{{dynamic}} {{dynamicDate}}. </span><span v-if="(additionalDynamic && displayAdditionalDynamic)">{{additionalDynamicText}}</span>  <span v-html="$options.filters.subscript(cmsText)"></span></p>
    </div>
</template>

<script>
    export default {
        name: "Disclaimer",
        props: [
            'cmsText',
            'additionalDynamic'
        ],
        data(){
            return {
                dynamic: 'This quotation is valid for orders placed before',
            }
        },
        computed:{
            dynamicDate: function(){
                let date =  new Date();
                date.setDate(date.getDate() + 7);

                // simple working days calc, not worrying about bank holidays etc
                let adjustedDate = [0, 6].indexOf(date.getDay());
                if (adjustedDate > -1) {
                    date.setDate(date.getDate() + (adjustedDate + 1)); // if the index is 0 it only requires 1 day, i.e 0 + 1, index 1 requires 2 days, 2 + 1
                }

                return date.toLocaleDateString("en-GB");
            },
            displayAdditionalDynamic: function() {
                return (this.appState !== 0);
            },
            appState: function() {
                return this.$store.state.STATE;
            },
            maintenance: function () {
                return this.$store.state.FINANCE_FILTER_MAINT;
            },
            mileage: function () {
                return this.$store.state.FINANCE_FILTER_MILEAGE;
            },
            term: function () {
                return this.$store.state.FINANCE_FILTER_TERM;
            },
            advance: function () {
                return this.$store.state.FINANCE_FILTER_ADVANCE;
            },
            additionalDynamicText: function() {
                return "Rates quoted are based on the following: term "
                + this.term + " months; "
                + this.advance + " advance rentals, "
                + this.mileage + " miles per annum and "
                + ((this.maintenance) ? "with" : "without")
                + " maintenance."
            }
        }
    }
</script>

<style scoped lang="stylus">
    .disclaimer
        margin-top 3rem
</style>